"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlgoliaIndexes = void 0;
var AlgoliaIndexes;
(function (AlgoliaIndexes) {
    AlgoliaIndexes["Forms"] = "forms";
})(AlgoliaIndexes || (exports.AlgoliaIndexes = AlgoliaIndexes = {}));
